import InfoIcon from "@/svg/InfoIcon.tsx";
import st from "@/styles/Ui.module.scss"
import {useTranslation} from "react-i18next";

const SessionExpiresWarn = () => {
    
    const {t} = useTranslation()
    
    return (
        <div className={st.session_expired}>
            <InfoIcon />
            <strong>
                {t("session_expired")}
            </strong>
        </div>
    )
}

export default SessionExpiresWarn